module.exports = __webpack_public_path__ + "static/media/zena-icons-animation-copywriting.4e3b8a71.gif";